import { Component } from '@angular/core';
import { IzzyIzzyActionCategoryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Izzy Action Categories') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyizzyactioncategory-form',
    templateUrl: './izzyizzyactioncategory.form.component.html'
})
export class IzzyIzzyActionCategoryFormComponent extends BaseFormComponent {
    public record!: IzzyIzzyActionCategoryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'categoryDetails', sectionName: 'Category Details', isExpanded: true },
            { sectionKey: 'hierarchyOrdering', sectionName: 'Hierarchy & Ordering', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'izzyActionCategories', sectionName: 'Izzy Action Categories', isExpanded: false },
            { sectionKey: 'izzyActions', sectionName: 'Izzy Actions', isExpanded: false }
        ]);
    }
}

